import Branch from "@/components/management/components/dashboard/Branch";
import Card from "@/components/management/components/dashboard/Card";
import Title from "@/components/management/components/dashboard/Title";
import { useUser } from "@/contexts/UserContext";
import {
  faBox,
  faChartBar,
  faClipboardList,
  faGear,
  faPrint,
  faTags,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Dashboard = () => {
  const { user } = useUser();
  const { t } = useTranslation();
  const [showBranchComponent, setShowBranchComponent] = useState(true);

  useEffect(() => {
    const handleUserChange = () => {
      const selectedBranch = user?.selectedBranch;
      setShowBranchComponent(!selectedBranch);
    };
    handleUserChange();
    window.addEventListener("storage", handleUserChange);
    return () => {
      window.removeEventListener("storage", handleUserChange);
    };
  }, [user]);

  return (
    <div className="bg-[#F8F8F8] p-8">
      <Title />
      <div>
        <Card />
        {showBranchComponent && <Branch />}
      </div>

      <div className="mt-12 gap-4">
        <h1 className="mb-4 text-2xl font-bold">
          {t("back.management.dashboard.quickAccess")}
        </h1>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-4 lg:grid-cols-3">
        <Link
          to="/menu/categories"
          className="cursor-pointer rounded bg-white p-4 shadow hover:bg-gray-200"
        >
          <FontAwesomeIcon icon={faTags} size="2x" />
          <p className="mt-2 text-center">
            {t("back.management.dashboard.category")}
          </p>
        </Link>
        <Link
          to="/menu/products"
          className="cursor-pointer rounded bg-white p-4 shadow hover:bg-gray-200"
        >
          <FontAwesomeIcon icon={faBox} size="2x" />
          <p className="mt-2 text-center">
            {t("back.management.dashboard.product")}
          </p>
        </Link>
        <Link
          to="/device/printers"
          className="cursor-pointer rounded bg-white p-4 shadow hover:bg-gray-200"
        >
          <FontAwesomeIcon icon={faPrint} size="2x" />
          <p className="mt-2 text-center">
            {t("back.management.dashboard.printer")}
          </p>
        </Link>
        <Link
          to="/orders"
          className="cursor-pointer rounded bg-white p-4 shadow hover:bg-gray-200"
        >
          <FontAwesomeIcon icon={faClipboardList} size="2x" />
          <p className="mt-2 text-center">
            {t("back.management.dashboard.order")}
          </p>
        </Link>
        <Link
          to="/reports"
          className="cursor-pointer rounded bg-white p-4 shadow hover:bg-gray-200"
        >
          <FontAwesomeIcon icon={faChartBar} size="2x" />
          <p className="mt-2 text-center">
            {t("back.management.dashboard.report")}
          </p>
        </Link>
        <Link
          to="/information"
          className="cursor-pointer rounded bg-white p-4 shadow hover:bg-gray-200"
        >
          <FontAwesomeIcon icon={faGear} size="2x" />
          <p className="mt-2 text-center">
            {t("back.management.dashboard.businessInformation")}
          </p>
        </Link>
      </div>
    </div>
  );
};

export default Dashboard;
